/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

const Divider = (props) => {
    const { text, customClass } = props;

    if (!text) return null;

    return (
        <div className={`${customClass} divider`}>
            <span />
            <span>{text}</span>
            <span />
        </div>
    );
};

Divider.defaultProps = {
    text: '',
    customClass: '',
};

Divider.propTypes = {
    text: PropTypes.string,
    customClass: PropTypes.string,
};

export default Divider;
